import * as React from 'react';
import { cn } from '@noor/lib/cn';

export type AppShellRootProps = React.ComponentProps<'div'>;

function AppShellRoot({ className, ...props }: AppShellRootProps) {
  return (
    <div
      data-slot="app-shell"
      className={cn('flex h-full min-h-0 w-full', className)}
      {...props}
    />
  );
}

export { AppShellRoot };
